<template>
  <button type="button" class="toolbarBtn"
    :class="{active: active}"
    @mousedown.prevent
    @click="onClick">
    <img src="~@/assets/img/CITEditor/unorderedlist.svg" alt="unoldered list" title="unoldered list" />
  </button>
</template>

<script>
export default {
  name: 'UnorderedList',
  props: [
    'active'
  ],
  methods: {
    onClick () {
      document.execCommand('insertUnorderedList', false)
    }
  }
}
</script>
